import * as Constants from '../constants/';

const INITIAL_STATE = {
  ecs: {},
  experiment: {}
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Constants.UPDATE_WELCOME_MAT:
      return {
        ...state,
        [action.name]: {
          shouldOpen: action.shouldOpen
        }
      };
    default:
      return state;
  }
}
